import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useLocation, useNavigate } from "react-router-dom";

import {
  GetProfileDetailsSegmentAPICall,
  SegmentStageDetailsAPICall,
} from "../SegmentUpdateAPICalls";

import BankStyles from "./Profile.module.scss";

import image from "../../../Components/assets/Images/bankupdateicon.svg";

import { browserName } from "react-device-detect";
import { getCookie } from "../cookies";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import ErrorSnackBar from "../../../Components/SnackBars/ErrorSnackBar";
import SucessSnackBar from "../../../Components/SnackBars/SucesssnackBar";
import keyboardicon from "../../../Components/assets/Images/panicongrey.svg";
import {
  GetProfileDetailsCommonAPICall,
  LocationCheckAPICall,
  SaveIpAddressAPICall,
} from "../../../shared/APICalls";
import axios from "axios";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function SegmentUpdateProfileDetails() {
  const navigate = useNavigate();

  const [loading, setloading] = useState(false);
  const [successMessage, setsuccessMessage] = useState("");
  const [userData, setUserData] = useState<any>();
  const [errorMessage, seterrorMessage] = useState("");
  const [rejectMessage, setrejectMessage] = useState("");
  const [IPAddress, setIPAddress] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    GetProfileDetails();
    const fetchIPAddress = async () => {
      try {
        const response = await axios.get(
          "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ",
        );
        // setIPAddress(response.data);
        setIPAddress(response.data?.ip);
      } catch (err: any) {}
    };
    fetchIPAddress();
  }, []);

  useEffect(() => {
    if (IPAddress !== "") {
      LocationCheckAPICall(IPAddress?.trim())
        .then((response: any) => {
          if (response.data.data) {
            sessionStorage.setItem("latitude", response.data.data.latitude);
            sessionStorage.setItem("longitude", response.data.data.longitude);
          }
        })
        .catch((error: any) => {
          seterrorMessage("latitude and longitude not found");
          setTimeout(() => {
            seterrorMessage("");
          }, 5000);
        });
    }
  }, [IPAddress]);

  const GetProfileDetails = () => {
    GetProfileDetailsCommonAPICall()
      .then((response: any) => {
        // console.log("GetProfileDetails", response.data.data);
        if (response.data?.data) {
          setUserData(response.data.data);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
      });
  };

  const SegmentStageDetails = () => {
    let obj: any = {
      request_id: null,
      stage: "segment_details",
    };
    SegmentStageDetailsAPICall(obj)
      .then((response: any) => {
        // console.log("responsestage", response.data.data);
        const resposeData = response.data;
        if (response.data.data.request_id) {
          sessionStorage.setItem(
            "segmentRequestid",
            response.data.data.request_id,
          );
        }
        if (response.data.data.ErrMessage) {
          setrejectMessage(response.data.data.ErrMessage);
        }
        if (resposeData.data.next_stage) {
          navigate(`/segmentUpdate/${resposeData.data.next_stage}`);
        }
      })
      .catch((error: any) => {});
  };

  const handleNext = () => {
    SegmentStageDetails();
  };

  return (
    <>
      <SucessSnackBar message={successMessage} />
      <SnackBar message={errorMessage} />
      <ErrorSnackBar message={rejectMessage} />
      <div className={BankStyles.mainWrapper}>
        <div className={BankStyles.wrapper}>
          <div className={BankStyles.step}>
            <img src={keyboardicon} /> Step 1 of 4
          </div>
          <div className={BankStyles.HeaderSection}>
            <p className={BankStyles.Header}>Your Profile Details</p>
          </div>
          <p className={BankStyles.subText}>Confirm your profile information</p>
          <div className={BankStyles.txtwrapper}>
            <Grid
              container
              rowSpacing={5}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Client Code"
                  variant="outlined"
                  value={userData?.clientCode ? userData.clientCode : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Full Name"
                  variant="outlined"
                  value={userData?.fullName ? userData.fullName : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Email"
                  variant="outlined"
                  value={userData?.email ? userData.email : ""}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  sx={{
                    fieldset: {
                      borderColor: "#E5E7EB",
                      borderRadius: "100px",
                      height: "60px",
                    },
                  }}
                  InputLabelProps={{
                    style: { color: "#111827", fontWeight: 500 },
                  }}
                  inputProps={{
                    sx: {
                      "&::label": {
                        fill: "#111827",
                        fontWeight: 500,
                      },
                      color: "var(--Black-Black-500, #6B7280)",
                      fontSize: "14px",
                    },
                  }}
                  id="outlined-basic"
                  label="Mobile"
                  variant="outlined"
                  value={userData?.mobile ? userData.mobile : ""}
                />
              </Grid>
            </Grid>
          </div>

          <div className={BankStyles.buttonStack}>
            <LoadingButton
              loading={loading}
              variant="contained"
              type="submit"
              id="linkUsingIFSCContinueButton"
              className={BankStyles.approveButton}
              sx={{
                fontSize: "12px",

                padding: "8px 70px",
                height: "50px",
              }}
              onClick={handleNext}
            >
              Continue
            </LoadingButton>
          </div>
        </div>
      </div>
    </>
  );
}
